import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './index.css';

const container = document.getElementById('root');

if (container === null) {
  // index.html owns this element. If it is gone the mount would fail with an
  // opaque null-deref deep inside React; say what actually went wrong instead.
  throw new Error('Mount failed: #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
